import { Space, Typography } from 'antd'

import { InputNumber } from '@eastcoal/formily/components/InputNumber'
import { ObjectField } from '@eastcoal/formily/exports/core'
import { useField } from '@eastcoal/formily/exports/react'

import { QuotaParamsType } from '@eastcoal/shared/enums/QuotaParamsType'

export const QuotaValueInputGroup = () => {
  const { value: parentValue, onInput } = useField<ObjectField>()

  const showSecondValue = parentValue?.type === QuotaParamsType.BETWEEN

  const onFirstValueChange = (value?: string) => {
    onInput({ ...parentValue, value1: value })
  }
  const onSecondValueChange = (value?: string) => {
    onInput({ ...parentValue, value2: value })
  }

  return (
    <Space>
      <InputNumber
        style={{ width: 120 }}
        value={parentValue.value1}
        onChange={onFirstValueChange as any}
      />
      {showSecondValue && (
        <>
          <div
            style={{
              width: '10px',
              margin: '15px 6px',
              borderBlockStart: '1px solid black'
            }}
          />
          <InputNumber
            style={{ width: 120 }}
            value={parentValue.value2}
            onChange={onSecondValueChange as any}
          />
        </>
      )}
      <Typography.Text style={{ textWrap: 'nowrap' }}>
        {parentValue.unit}
      </Typography.Text>
    </Space>
  )
}
